import { apiRequest } from "./apiService";

export const fetchMe = () => apiRequest("/me", "GET");
